import { render } from "./CustomizationField.vue?vue&type=template&id=66cda891"
import script from "./CustomizationField.vue?vue&type=script&lang=js"
export * from "./CustomizationField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__